export default __webpack_public_path__ + "static/media/PRESTIGIO_IMPERO-LUCIDO_MESH_120X278_03_265.d07211b0.jpg";